module.exports = __webpack_public_path__ + "img/login-bg.fc78357a.png";